<app-dialog-close-button class="delete-dialog__close" (closed)="cancel()"></app-dialog-close-button>

<div class="delete-dialog">
  <div class="delete-dialog__header">
    <span class="delete-dialog__icon" aria-hidden="true">
      <vng-icon name="warning" [outline]="false" [size]="22"></vng-icon>
    </span>
    <h2 class="delete-dialog__title" vng-dialog-title>Delete your account</h2>
  </div>

  <p class="delete-dialog__lede">
    Deleting your FlyMSG account is <strong>permanent</strong>. Everything below is erased and
    <strong>cannot be recovered</strong> — not by you, and not by our support team.
  </p>

  <ul class="delete-dialog__list">
    <li *ngFor="let item of consequences">
      <vng-icon name="close" [outline]="false" [size]="16" aria-hidden="true"></vng-icon>
      <span>{{ item }}</span>
    </li>
  </ul>

  <div class="delete-dialog__notice" role="note">
    <vng-icon name="warning" [outline]="false" [size]="20" aria-hidden="true"></vng-icon>
    <p>
      There is no undo, no grace period and no export after the fact. If you only want to stop being billed, cancel your
      plan on the
      <a href="#" class="delete-dialog__link" (click)="goToSubscription(); $event.preventDefault()">Subscription</a>
      tab instead — your content stays put.
    </p>
  </div>

  <form class="delete-dialog__form" [formGroup]="form" (ngSubmit)="confirm()">
    <vng-textarea
      label="Why are you deleting your account?"
      placeholder="Tell us what led to this — it's the only feedback we get, and it's required to continue."
      [rows]="4"
      resize="vertical"
      [maxlength]="1000"
      [formControl]="form.controls['reason']"
      [flyMsgIgnore]="true"
      [error]="
        !form.controls['reason'].touched
          ? ''
          : form.controls['reason'].hasError('required')
            ? 'A reason is required to delete your account.'
            : form.controls['reason'].hasError('minlength')
              ? 'Please give us a little more detail (at least 10 characters).'
              : form.controls['reason'].hasError('maxlength')
                ? 'Please keep your reason under 1000 characters.'
                : ''
      "
    ></vng-textarea>

    <vng-dialog-actions class="delete-dialog__actions">
      <button type="button" vng-button variant="outline" (click)="cancel()">Keep my account</button>
      <button type="submit" vng-button variant="destructive" [disabled]="form.invalid">
        <vng-icon name="delete" [outline]="false" [size]="18"></vng-icon>
        Delete My Account
      </button>
    </vng-dialog-actions>
  </form>
</div>
